import { connect } from 'react-redux';
import LeaderboardTable from '../components/leaderboard_table';
import { selectIsManagerSite, selectParentEvent, selectResolveTiesHref, selectDisplayedFlags, selectHidesPurse, selectVisibleColumns } from '../selectors'

// Self-sufficient per (eventId, resultScopeId, isFavorite): every scope-level
// field comes straight from the store, so parents only pass identity props.
// The favorites table never shows cut lines, section lines, or totals — that
// is gated here to keep the behavior explicit.
const mapStateToProps = (state, ownProps) => {
  const eventId = String(ownProps.eventId);
  const scopeId = ownProps.resultScopeId;
  const isManagerSite = selectIsManagerSite(state);
  const eventState = state.event[eventId];
  const data = eventState?.data ?? {};
  const parentEvent = selectParentEvent(state, eventId);
  const isFullTable = !ownProps.isFavorite;
  // The total purse line follows the purse column off the portal (legacy hid
  // tr.total_purse_allocated with the purse cells); total points stays.
  const showsTotalPurse = isFullTable && !selectHidesPurse(state);

  return {
    resultScope: data.scopes?.[scopeId] ?? [],
    favorites: isManagerSite ? [] : (eventState?.favorites || []),
    displayedFlags: selectDisplayedFlags(state, eventId),
    currencySymbol: state.leaderboardV2.currencySymbol,
    purseDecimalPlaces: state.leaderboardV2.purseDecimalPlaces,
    hasPositionColumn: (data.columns || []).some((column) => column.id === 'position'),
    // The starting-hole note keys on Thru cells that are actually rendered, so
    // it reads the same visible columns and rounds header_row/aggregate_row do.
    columns: selectVisibleColumns(state, eventId),
    rounds: data.rounds ?? {},
    isManagerSite,
    displayCut: isFullTable ? data.displayCut : false,
    cutListPosition: isFullTable ? data.cutListPosition?.[scopeId] : '',
    cutListLabel: isFullTable ? data.cutListLabel?.[scopeId] : null,
    resolveTiesHref: isFullTable ? selectResolveTiesHref(state, eventId, scopeId) : null,
    sectionLines: isFullTable ? (data.sectionLines?.[scopeId] || {}) : {},
    totalPurseAllocated: showsTotalPurse ? (parentEvent?.totalPurseAllocated ?? null) : null,
    totalPointsAllocated: isFullTable ? (parentEvent?.totalPointsAllocated ?? null) : null,
  };
};

export default connect(mapStateToProps)(LeaderboardTable);
